import { render, staticRenderFns } from "./HowToSteps.vue?vue&type=template&id=a508218c&"
import script from "./HowToSteps.vue?vue&type=script&lang=js&"
export * from "./HowToSteps.vue?vue&type=script&lang=js&"
import style0 from "./HowToSteps.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports